import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { IMyOptions, ToastService } from 'ng-uikit-pro-standard';
import { TeamService } from 'app/services/team.service';
import { UserService } from 'app/services/user.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { User } from 'app/models/user';
import { Team } from 'app/models/team';
import { WorkflowExec, WorkflowStatus } from 'app/models/workflow-exec';
import { WorkflowExecutionService } from 'app/services/workflow-execution.service';
import { finalize, map, distinct } from 'rxjs/operators';
import { from } from 'rxjs';
import { ContactService } from 'app/services/contactService';
import { Contact } from 'app/models/contact';
import { DateRangeService } from 'app/services/date-range.service';
import { DateRange } from 'app/models/date-range';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';
import { getExecVariableValue } from "app/helpers/utils";
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
@Component({
  selector: 'app-workflow-status',
  templateUrl: './workflow-status.component.html',
  styleUrls: ['./workflow-status.component.scss']
})
export class WorkflowStatusComponent implements OnInit, AfterViewInit {

  searchString: string = '';

  tableLimitSelect = [5, 10, 20, 30, 50, 100];
  selectedTableLimit: number = 5;

  loadingNotifyIds:number[] = [];

  usersList: User[];
  teamsList: Team[];
  contactsList: Contact[];

  workflowTemplateNames: string[] = [];

  workflowExecs: WorkflowExec[] = [];
  unfilteredWorkflowExecs: WorkflowExec[] = [];

  execsTotalCount = 0;
  pageOffset = 0;

  isLoading: boolean = false;
  isFilterCollapsed: boolean = true;

  startFilterDateRange: DateRange;
  searchFilter: string = '';
  workflowNamesFilter: string[];
  initiatorUserIdFilter: number[];
  initiatorTeamIdFilter: number[];
  assignedToUserIdFilter: number[];
  assignedToTeamIdFilter: number[];
  assignedToContactIdFilter: number[];
  inProgressFilter: boolean;
  isCompletedFilter: boolean;
  isTimedOutFilter: boolean;
  dueByFilter: boolean;
  isOverdueFilter: boolean;
  dueOnFilterDateRange: DateRange;
  completedOnFilterDateRange: DateRange;
  timedOutOnFilterDateRange: DateRange;

  sorts = [
    { prop:'dueCompleted' , dir: 'desc' }
  ];

  @ViewChild(DatatableComponent, { static: true }) table: DatatableComponent;
  @ViewChild('startDateRangePicker', { static: true, read: DaterangepickerDirective }) startDateRangePicker: DaterangepickerDirective;

  constructor(private userService: UserService, private teamService: TeamService, private formBuilder: FormBuilder,
              private workflowExecutionService: WorkflowExecutionService, private toastService: ToastService,
              private contactService: ContactService, public dateRangeService: DateRangeService,
              private ecoDocsTitleService: EcoDocsTitleService, private router: Router, private activatedRoute: ActivatedRoute) {                
  }

  ngOnInit() {
    this.ecoDocsTitleService.setTitle('Worflow Status', false);  
    this.searchFilter = '';
    this.workflowNamesFilter = [];
    this.startFilterDateRange = this.dateRangeService.allTime; //this.dateRangeService.nullDateRange;
    this.initiatorUserIdFilter = [];
    this.initiatorTeamIdFilter = [];
    this.assignedToUserIdFilter = [];
    this.assignedToTeamIdFilter = [];
    this.assignedToContactIdFilter = [];
    this.inProgressFilter = false;
    this.isCompletedFilter = false;
    this.isTimedOutFilter = false;
    this.dueByFilter = false;
    this.isOverdueFilter = false;
    this.dueOnFilterDateRange = this.dateRangeService.nullDateRange;
    this.completedOnFilterDateRange = this.dateRangeService.nullDateRange;
    this.timedOutOnFilterDateRange = this.dateRangeService.nullDateRange;

    this.teamService.getAll().subscribe(r => {
      this.teamsList = r;
    });

    this.userService.getAll().subscribe(r => {
      this.usersList = r;
    });

    this.contactService.getAll().subscribe(c => {
      this.contactsList = c;
    });

    this.loadingNotifyIds = [];
    
    // Listen for query params on initialization
    this.activatedRoute.queryParams.subscribe(params => {
      this.pageOffset = (params.page || 1) - 1;
      this.sorts[0] = {prop: params.sort_by || '', dir: params.sort_dir || ''};
      this.searchFilter = params.search || '';
      this.startFilterDateRange = (params.start_date && params.end_date)? {startDate: moment(params.start_date), endDate: moment(params.end_date)}: this.dateRangeService.allTime;
      this.initiatorUserIdFilter = [].concat(params['initiator_user_id[]'] || []).map(Number);
      this.initiatorTeamIdFilter = [].concat(params['initiator_team_id[]'] || []).map(Number);
      this.assignedToUserIdFilter = [].concat(params['target_user_id[]'] || []).map(Number);
      this.assignedToTeamIdFilter = [].concat(params['target_team_id[]'] || []).map(Number);
      this.assignedToContactIdFilter = [].concat(params['target_contact_id[]'] || []).map(Number);
      this.inProgressFilter = params.filter_in_progress === 'true';
      this.isCompletedFilter = params.filter_is_completed === 'true';
      this.isTimedOutFilter = params.filter_is_timed_out === 'true';
      this.dueByFilter = params.filter_due_by === 'true';
      this.isOverdueFilter = params.filter_all_overdue === 'true';
      this.dueOnFilterDateRange = (params.start_date_in_progress && params.end_date_in_progress)? {startDate: moment(params.start_date_in_progress), endDate: moment(params.end_date_in_progress)}: this.dateRangeService.nullDateRange;
      this.completedOnFilterDateRange = (params.start_date_completed && params.end_date_completed)? {startDate: moment(params.start_date_completed), endDate: moment(params.end_date_completed)}: this.dateRangeService.nullDateRange;
      this.timedOutOnFilterDateRange = (params.start_date_timed_out && params.end_date_timed_out)? {startDate: moment(params.start_date_timed_out), endDate: moment(params.end_date_timed_out)}: this.dateRangeService.nullDateRange;

      // After setting the filters, fetch data based on these filters
      this.getPage();
    });
    
    this.getPage();
  }
  
  private getPage(pageNumber: number = 1) {
    this.isLoading = true;
    this.workflowExecutionService.list(pageNumber,
                                      this.sorts[0]?.prop || '',
                                      this.sorts[0]?.dir || '',
                                      this.searchFilter,
                                      this.startFilterDateRange,
                                      this.initiatorUserIdFilter,
                                      this.initiatorTeamIdFilter,
                                      this.assignedToUserIdFilter,
                                      this.assignedToTeamIdFilter,
                                      this.assignedToContactIdFilter,
                                      this.inProgressFilter,
                                      this.isCompletedFilter,
                                      this.isTimedOutFilter,
                                      this.dueByFilter,
                                      this.isOverdueFilter,
                                      this.dueOnFilterDateRange,
                                      this.completedOnFilterDateRange,
                                      this.timedOutOnFilterDateRange
                                      ).pipe(finalize(() => {
      this.isLoading = false;
    })).subscribe((resp) => {
      this.execsTotalCount = resp.total;
      this.pageOffset = resp.current_page - 1;
      let w = resp.data;
      this.workflowExecs = w;
      this.unfilteredWorkflowExecs = w;
      this.workflowTemplateNames = [];
      from(this.workflowExecs).pipe(map((w) => w.workflow_template.name),
        distinct()).subscribe((n) => {
          this.workflowTemplateNames.push(n);
        });

    });
  }

  onPageChange(pageInfo) {
    this.getPage(pageInfo.offset + 1);
  }
  
  onSort(event) {
    // update the sorts array with the new sorting preference
    this.sorts = event.sorts;
    this.getPage(this.pageOffset + 1);
  }

  ngAfterViewInit() {
  }

  dueCompletedComparator(valueA, valueB, rowA: WorkflowExec, rowB: WorkflowExec, sortDirection) {
    let rowAField = (rowA.due_on || rowA.updated_at).valueOf();
    let rowBField = (rowB.due_on || rowB.updated_at).valueOf();
    
    return ((rowAField > rowBField) as any) - ((rowAField < rowBField) as any);
  }
  innerWidth() {
    return window.innerWidth;
  }

  notify(workflowExecId: number) {
    this.loadingNotifyIds.push(workflowExecId);
    this.workflowExecutionService.notifyCurrentStepTargets(workflowExecId).pipe(finalize(()=>{
      this.loadingNotifyIds = this.loadingNotifyIds.filter(id => id != workflowExecId);
    })).subscribe(()=>{
      this.toastService.success('Nofitication Sent!');
    });
  }
  
  public get workflowStatus() : typeof WorkflowStatus {
    return WorkflowStatus;
  }

  getWorkflowStatusLabel(status: WorkflowStatus) {
    var result = '';
    switch (status) {
      case WorkflowStatus.WORKFLOW_STATUS_COMPLETED:
        result = 'Completed';
        break;
      case WorkflowStatus.WORKFLOW_STATUS_IN_PROGRESS:
          result = 'In Progress';
          break;
      case WorkflowStatus.WORKFLOW_STATUS_PROCESSING:
        result = 'Processing';
        break;
      case WorkflowStatus.WORKFLOW_STATUS_TIMED_OUT:
        result = 'Timed-Out';
        break;
    }

    return result;
  }
  updateFilter() {
    this.getPage(this.pageOffset + 1);

    // Update the URL's query parameters without refreshing the page
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        "page": (this.pageOffset + 1).toString(),
        "sort_by": this.sorts[0]?.prop || '',
        "sort_dir": this.sorts[0]?.dir || '',
        "search": this.searchFilter,
        "start_date": this.startFilterDateRange?.startDate?.toISOString() || '',
        "end_date": this.startFilterDateRange?.endDate?.toISOString() || '',
        "initiator_user_id[]": this.initiatorUserIdFilter,
        "initiator_team_id[]": this.initiatorTeamIdFilter,
        "target_user_id[]": this.assignedToUserIdFilter,
        "target_team_id[]": this.assignedToTeamIdFilter,
        "target_contact_id[]": this.assignedToContactIdFilter,
        "filter_in_progress": this.inProgressFilter,
        "filter_is_completed": this.isCompletedFilter,
        "filter_is_timed_out": this.isTimedOutFilter,
        "filter_due_by": this.dueByFilter,
        "filter_all_overdue": this.isOverdueFilter,
        "start_date_in_progress": this.dueOnFilterDateRange?.startDate?.toISOString() || '',
        "end_date_in_progress": this.dueOnFilterDateRange?.endDate?.toISOString() || '',
        "start_date_completed": this.completedOnFilterDateRange?.startDate?.toISOString() || '',
        "end_date_completed": this.completedOnFilterDateRange?.endDate?.toISOString() || '',
        "start_date_timed_out": this.timedOutOnFilterDateRange?.startDate?.toISOString() || '',
        "end_date_timed_out": this.timedOutOnFilterDateRange?.endDate?.toISOString() || ''
      },
      queryParamsHandling: 'merge', // merge with the current queryParams
      replaceUrl: true // does not add to browser history
    });
  }
}
